import styled from "styled-components";
import { Link } from 'react-router-dom';

export const PageContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 20px;
`;

export const ContentWrapper = styled.div`
  max-width: 700px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
`;

export const RedeemButton = styled.button<{ loading?: boolean, disabled?: boolean }>`
  background: ${({ theme, disabled }) => disabled ?  theme?.colors?.text?.muted: theme?.colors?.theme?.brandColor3};
  color: ${({ disabled }) => disabled ? 'gray' : 'white'};
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: ${({ loading, disabled }) => (loading || disabled ? 'not-allowed' : 'pointer')};
  position: relative;
  
  &:disabled {
    opacity: 0.7;
  }

  ${({ loading }) => loading && `
    color: transparent;
    
    &:after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 16px;
      height: 16px;
      margin: -8px 0 0 -8px;
      border: 2px solid #ffffff;
      border-right-color: transparent;
      border-radius: 50%;
      animation: spin 0.75s linear infinite;
    }

    @keyframes spin {
      from { transform: rotate(0deg); }
      to { transform: rotate(360deg); }
    }
  `}
`;

export const LoginMessage = styled.div`
  text-align: center;
  color: white;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;

  p {
    font-size: 16px;
    margin: 0;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`;

export const GreenText = styled.span`
  color: ${({ theme }) => theme.colors.theme.success};
  text-align: center;
  font-feature-settings: 'liga' off, 'clig' off;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const NormalText = styled.span`
    color: ${({ theme }) => theme.colors.text.headings};
    text-align: left;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
`;

export const FrameContainer = styled.div`
  box-shadow: 0px 5px 32px 0px rgba(0, 67, 101, 0.08);
  background-color: ${({ theme }) => theme.colors.theme.contentBg};
  display: flex;
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
  padding: 24px;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  text-align: left;
`;

export const TextButton = styled.button`
    background: none;
    border: none;
    padding: 0;
    font-weight: bold;
    text-decoration: underline;
    color: inherit;
    cursor: pointer;
    font-family: inherit;
    font-size: inherit;

    &:hover {
        opacity: 0.8;
    }
`;

export const SuccessMessage = styled.div`
    color: ${({ theme }) => theme.colors.theme.success};
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 600;
`;

export const WalletLink = styled(Link)`
    color: ${({ theme }) => theme?.colors?.text?.headings};
    text-decoration: underline;
    font-weight: bold;
    cursor: pointer;
    
    &:hover {
        opacity: 0.8;
    }
`;
